import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "customer__container" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 2,
  class: "wrapper-customer-waitlist"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "customer__title" }, "Waitlist", -1)),
    ($setup.showSpinner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (!$setup.waitlist.length && !$setup.showSpinner)
      ? (_openBlock(), _createBlock($setup["CustomerDetailsCardEmpty"], {
          key: 1,
          class: "empty-card",
          "img-path": "assets/icons/icon-customer-waitlist.svg",
          message: "You are not currently on any waitlists"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waitlist, (item, index) => {
            return (_openBlock(), _createBlock($setup["CustomerDetailsCardWaitlist"], {
              class: "customer-waitlist",
              key: index,
              data: item,
              onClick: ($event: any) => ($setup.onWaitlist(item))
            }, null, 8, ["data", "onClick"]))
          }), 128))
        ]))
  ]))
}